import React from 'react';
import { useInlineToast } from './InlineToastManager';

export const InlineToastZone = ({ zone }) => {
    const { zones, removeToast } = useInlineToast();
    const messages = zones[zone] || [];

    return (
        <div className="flex flex-col gap-2 my-1 ">
            {messages.map(toast => {
                const bg = {
                    success: 'bg-green-100 text-green-800 border-green-400',
                    error: 'bg-red-100 text-red-800 border-red-400',
                    info: 'bg-blue-100 text-blue-800 border-blue-400',
                }[toast.type] || 'bg-gray-100 text-gray-800 border-gray-400';

                return (
                    <div
                        key={toast.id}
                        className={`border px-4 py-2 rounded ${bg} relative`}
                    >
                        {toast.message}
                        <button
                            onClick={() => removeToast(zone, toast.id)}
                            className="absolute top-1 right-2 text-xs text-gray-500 hover:text-black"
                        >
                            ×
                        </button>
                    </div>
                );
            })}
        </div>
    );
};
